import { createSlice } from "@reduxjs/toolkit";

export const rowsSlice = createSlice({
  name: "rows",
  initialState: {
    clickedRowData: null,
  },
  reducers: {
    saveClickedRow: (state, action) => {
      state.clickedRowData = action.payload;
    },
  },
});

export const { saveClickedRow } = rowsSlice.actions;
export default rowsSlice.reducer;
